import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import dayjs from "dayjs";
import {
  Button,
  CircularProgress,
} from "@mui/material";
import { ReactComponent as PdfIcon } from "../../assets/image/svg/pdfIcon.svg";
import {
  getGenericModalProps,
  GenericModal,
  customStyle
} from "../../features/viewOrder/ViewOrderUtils";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { editGrnRowsData, popupType } from "../../types/types";
import Search from "../../components/dms_common/Search";
import { getConfigData } from "../../services/configurationService";
import {
  getGrnInfoByInvoice,
  updateGrnStatus,
} from "../../services/manageOrderService";
import { createScrollHandler, handleScroll, safeStringify, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getMetaData1, metaData2, getViewGrnDetailsConfig } from "./ViewGrnDetailsConfig";
import "./ViewGrnDetails.css";
import { Loader } from "../../components/loader/Loader";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import FormHeader from "../../components/dms_common/FormHeader";
import CustomAccordian from "../../components/dms_common/CustomAccordian";
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import Header from "../../components/dms_common/Header";
import { defaultSearchFunction, filterData } from "../../components/dms_common/DmsCommonServices";
import OrderCancelModal from "../viewOrder/OrderCancelModal";
import { downloadGrnReport } from "../../services/manageReportService";
import { analytics, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { useDispatch } from "react-redux";
import NewDiscountModalPrimary from "../claimsNew/modals/NewDiscountModalPrimary";
import useShortcutKeys from "../../components/dms_common/ShortcutKeys";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
 
const ViewGrnDetails = () => {
  let { orderId } = useParams();
  orderId = decodeURIComponent(orderId ?? "")
   const initialGenericModalProps: GenericModal = {
    open: false,
    type: "success",
    message: "",
  };

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const [rows, setRows] = useState<editGrnRowsData[]>([]);
  const [data, setData] = useState<editGrnRowsData[]>([]);
  const [loader, setLoader] = useState(true);
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [totalCaseQuantity, setTotalCaseQuantity] = useState<number>(0);
  const [totalPieceQuantity, setTotalPieceQuantity] = useState<number>(0);
  const [totalOtherQuantity, setTotalOtherUnitQuantity] = useState<number>(0);
  const [totalProducts, setTotalProducts] = useState<number>(0);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [totalTaxAmount, setTotalTaxAmount] = useState<number>(0);
  const [rejectionReason, setRejectionReason] = useState<string>("");
  const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
  const [grnSheetLoader, setGrnSheetLoader] = useState<boolean>(false);
  const [actionButtons, setActionButtons] = useState<any[]>([]);
  const [primaryOrderStages, setPrimaryOrderStages] = useState<any[]>([]);
  const [getGrnStages, setGrnStages] = useState<any[]>([]);
  const [rejectionReasonsArray, setrejectionReasonArray] = useState<any[]>([]);
  const [orderData, setOrderData] = useState<any>({});
  const [deliveryData, setDeliveryData] = useState<any>({});
  const [outletCode, setOutletCode] = useState<string>("");
  const [orderStatusUpdateLoader, setOrderStatusUpdateLoader] =
    useState<boolean>(false);
  const [searchedValue, setSearchedValue] = useState('');
  const [isScrolling, setIsScrolling] = useState(false);
  const [showPricePerPiece, setShowPricePerPiece] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [isRejectCallBack, setRejectCallBack] = useState<boolean>(false);
  const [partialAcceptGrnButtonState, setPartialAcceptGrnButtonState] = useState<boolean>(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [getRemarksStatus,setRemarksStatus] = useState(false);
  const [deliveryDatePrimary, setDeliveryDatePrimary] = useState<string>("");
  const [isDownloading, setIsDownloading] = useState<boolean>(false); // New state to track full download process
  const isEPOD = useRef<boolean>(false);
  const showTaxPercentage = useRef<boolean>(true);

  const [scrollTop, setScrollTop] = useState<number>(0); 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const primaryOrderPath = pathname.includes('primaryOrder');
  const path = primaryOrderPath ? 'purchase/viewPrimaryOrders' : 'purchase/grn';

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  }

  const getRejectionReasonArray = async () => {
    try{
      const rejectionReaons = await getConfigData("dms_configuration", "grnRejectionReasons");
      setrejectionReasonArray(rejectionReaons[0]?.configValue ?? []);
    }catch (e) {
       await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching GRN Rejection Reasons - ViewGrnDetails.tsx",
        `Failed to fetch GRN rejection reasons for orderId ${orderId}. Error: ${(e as Error).message}`,
        safeStringify({ e, orderId })
      );
      console.error("Error while fetching configs", e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  }
  useEffect(() => {
  try {
      const authContext = JSON.parse(localStorage?.authContext || "{}");
      isEPOD.current = authContext.user?.extendedAttributes?.epod === "yes" ? true : false;
    } catch (e) {
      console.error("Failed to parse authContext from localStorage:", e);
      isEPOD.current = false;
    }
  }, []);

  const closeCallbackForReject = async () => {
    try {
      setOrderStatusUpdateLoader(true);
      setRejectionReason(rejectionReason);
      setRejectCallBack(false);
      let requestBody = {
        invoiceNumber: orderData?.invoiceNumber,
        grnStatus: "REJECTED",
        reason: rejectionReason,
      };
      await updateGrnStatus(requestBody).then(() => {
        logEvent(analytics, "grn_rejected", {
          "distributor_id": orderData.outletCode,
          "grn_id" : orderData.grnNumber,
          "order_id" : orderData.id,
          "rejection_reason" : rejectionReason,
          "total_value" : orderData.totalAmount
        })
        console.log(orderData.id,orderData.grnNumber,rejectionReason,orderData.totalAmount,orderData.outletCode);
        const updatedGenericModalProps = getGenericModalProps(
          "success",
          "GRN Rejected Successfully.",
          "Continue",
          "",
          () => setGenericModalProps(initialGenericModalProps)
        );
        setGenericModalProps(updatedGenericModalProps);
      }).catch((error: any) => {
            
        logEvent(analytics, "grn_rejection_failed", {
          "distributor_id": orderData.outletCode,
          "grn_id" : orderData.grnNumber,
          "order_id" : orderData.id,
          "error_reason":error
        });
        console.log(orderData.id,orderData.grnNumber,error);

      const updatedGenericModalProps = getGenericModalProps(
        "error",
        "Failed to Update Status",
        "Continue",
        "",
        () => setGenericModalProps(initialGenericModalProps)
      );
      setGenericModalProps(updatedGenericModalProps);
      });

      init(orderId??"")
    } catch (error: any) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "GRN Rejection Failed - ViewGrnDetails.tsx",
        `Failed to reject GRN for orderId ${orderId}. Error: ${error.message}`,
        safeStringify({ error, orderId, requestBody: { invoiceNumber: orderData?.invoiceNumber, grnStatus: "REJECTED", reason: rejectionReason } })
      );
      console.error(error);
       const updatedGenericModalProps = getGenericModalProps(
                "error",
                "Failed to Update Status",
                "Continue",
                "",
                () => setGenericModalProps(initialGenericModalProps)
              );
      setGenericModalProps(updatedGenericModalProps);
    }finally {
      setOrderStatusUpdateLoader(false);
    }
  }
  const downloadGrnSheet = async () => {
    if (isDownloading) return; 
    try{
      setIsDownloading(true);
      setGrnSheetLoader(true);
       const reportIdConfig = await getConfigData(
          "dms_configuration",
          "grnSheetReportId"
        );

      const reportId = reportIdConfig[0]?.configValue ?? "";
      const startTime = window.performance.now(); 

    await downloadGrnReport(
      reportId,
      "invoiceNumber",
      String(orderId),
      setSnackbarOpen,
      setIsDownloading
    )
    const endTime = window.performance.now(); 
    const durationSeconds = (endTime - startTime);

    logEvent(analytics, "grn_downloaded", {
      "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
      "grn_id" : orderData.grnNumber,
      "download_format": "pdf",
      "download_time": durationSeconds
    });
    console.log("download-grn",durationSeconds,orderData.grnNumber);

    }catch(e){
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Download GRN Failed - ViewGrnDetails.tsx",
        `Failed to download GRN report for orderId ${orderId}. Error: ${(e as Error).message}`,
        safeStringify({ e, orderId, distributor_id: JSON.parse(localStorage.authContext).user.loginId })
      );
      console.log(e)
    }finally {
      setGrnSheetLoader(false);
      setIsDownloading(false);
    }
  }

  const handleOrderStatusChange = async (status: string) => {
    try {
      if (status === "PARTIALLY_ACCEPTED") {
        
        navigate(`/dashboard/${path}/editGrnDetails/${encodeURIComponent(orderId??"")}`, {
          state: {
            orderData: orderData,
            invoiceDetails: data,
            deliveryData: deliveryData,
            totalFooterValue: totalFooterValue,
            outletCode: outletCode,
            currencySymbol: currencySymbol
          },
        });
      } else {
        let requestBody: {
          invoiceNumber: any;
          grnStatus: string;
          rejectionReason?: string;
        } = {
          invoiceNumber: orderData?.invoiceNumber,
          grnStatus: status,
        };

        setOrderStatusUpdateLoader(true);

        if (status === "REJECTED") {
          setRejectCallBack(true);
          setRejectionReason("");
        }

        if (status === "ACCEPTED") {
          const pageLoadTrace: PerformanceTrace = trace(performance, "handle_grn_status_change_load_time");
          pageLoadTrace.start();
          const response = await updateGrnStatus(requestBody).then(
            () => {
              logEvent(analytics, "grn_accepted", {
                "distributor_id": orderData.outletCode,
                "grn_id" : orderData.grnNumber,
                "order_id" : orderData.id,
                "sku_count" : orderData.lineCount,
                "total_value" : orderData.totalAmount
              });
              console.log(orderData.id,orderData.grnNumber,orderData.lineCount,orderData.totalAmount,orderData.outletCode);
              const updatedGenericModalProps = getGenericModalProps(
                "success",
                "GRN Accepted and Stock has been updated Successfully.",
                "Continue",
                "",
                () => setGenericModalProps(initialGenericModalProps)
              );
            setGenericModalProps(updatedGenericModalProps);
            }
          ).catch((error: any) => {
            
            logEvent(analytics, "grn_acceptance_failed", {
              "distributor_id": orderData.outletCode,
              "grn_id" : orderData.grnNumber,
              "order_id" : orderData.id,
              "error_reason":error
            });
            console.log(orderData.id,orderData.grnNumber,error);

          const updatedGenericModalProps = getGenericModalProps(
            "error",
            "Failed to Update Status",
            "Continue",
            "",
            () => setGenericModalProps(initialGenericModalProps)
          );
          setGenericModalProps(updatedGenericModalProps);
          });
          pageLoadTrace.stop();

        init(orderId ?? "");
        }
      }
    } catch (error: any) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "GRN Status Update Failed - ViewGrnDetails.tsx",
        `Failed to update GRN status to ${status} for orderId ${orderId}. Error: ${error.message}`,
        safeStringify({ error, orderId, requestBody: { invoiceNumber: orderData?.invoiceNumber, grnStatus: status } })
      );
      console.error(error);
        const updatedGenericModalProps = getGenericModalProps(
                "error",
                "Failed to Update Status",
                "Continue",
                "",
                () => setGenericModalProps(initialGenericModalProps)
              );
            setGenericModalProps(updatedGenericModalProps);
    } finally {
      setOrderStatusUpdateLoader(false);
    }
  };

  const toggleTaxInfoCollapsedStatus = (
    paramRow: editGrnRowsData,
    collapsed: boolean
  ) => {
    setRows((prevRows: editGrnRowsData[]) => {
      return prevRows.map((prevRow: editGrnRowsData) =>
        paramRow?.id === prevRow?.id ? { ...prevRow, collapsed } : prevRow
      );
    });
  };

  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode( ConfigDictionary?.batchIdConfiguration  ? paramRow?.batchId : paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };

  const columns: any[] = [...getViewGrnDetailsConfig(toggleTaxInfoCollapsedStatus,orderData?.grnStatus,getRemarksStatus, handlePromotionModalVisibility, showPricePerPiece,showTaxPercentage.current)?.columns];
    const getTotalQuantities = (config: any): string[] => {
    const { packUnitLabelPrimary, caseUnitLabelPrimary, otherUnitLabelPrimary } = config;
  
    return [
      caseUnitLabelPrimary ? `${totalCaseQuantity} ${caseUnitLabelPrimary}` : "",
      otherUnitLabelPrimary ? ` ${totalOtherQuantity} ${otherUnitLabelPrimary}` : "",
      packUnitLabelPrimary ? ` ${totalPieceQuantity} ${packUnitLabelPrimary}` : ""
    ].filter(Boolean); // Removes empty values
  };

  const getAllOrderDetailsDataMethod = async (orderId: string) => {
    try {

      setCurrencySymbol(ConfigDictionary?.currency ? ConfigDictionary?.currency : "");
      const symbol = ConfigDictionary?.currency ? ConfigDictionary?.currency : "";
      const orderFulfillmentConfigPrimary = ConfigDictionary?.orderFulfillmentTimePrimary ? ConfigDictionary?.orderFulfillmentTimePrimary  : 2

      const grnInfoOfInvoice = await getGrnInfoByInvoice(orderId || "");
      const data = grnInfoOfInvoice?.data?.features[0] ?? {};

      if (grnInfoOfInvoice.status === 200) {
        logEvent(analytics, "grn_details_viewed", {
          "distributor_id": data.outletCode,
          "grn_id" : data.grnNumber,
          "order_id" : data.id
        });
        console.log(data.id, data.outletCode,data.grnNumber)
        setDeliveryDatePrimary(dayjs(data?.creationTime).add(orderFulfillmentConfigPrimary , 'day').format('YYYY-MM-DD HH:mm:ss'))
        const summaryDiscount = data?.discountInfo
          ?.find((item: any) => item.discountType === "Summary"); 

        const totalDiscount = summaryDiscount 
              ? summaryDiscount.discount : "0"; 
        setTotalDiscount(totalDiscount);

        const totalSkuCount = data?.lineCount
        setTotalPieceQuantity(data?.totalPieceQuantity);
        setTotalOtherUnitQuantity(data?.totalOtherUnitQuantity);
        setTotalCaseQuantity(data?.totalCaseQuantity);
        setTotalProducts(totalSkuCount);
        setDeliveryData(data?.deliveryInfo);
        setOrderData(data);
      }

      let totalAmount = 0;
      let totalInitialAmount = 0;
      let taxAmount :number  = 0;
      let totalFinalAmount = 0;
      let footerCaseQuantity = 0
      let footerPieceQuantity = 0
      let footerOtherQuantity = 0
      if (grnInfoOfInvoice.status === 200) {
        setOutletCode(data?.outletCode);
        let responseArray: editGrnRowsData[] = [];

        data?.salesDetails?.forEach((item: any, index: any) => {
          const {
            skuDescription,
            category,
          } = item?.productInfo;

          const {
            skuCode,
            casePrice,
            type,
            initialCaseQuantity,
            initialPieceQuantity,
            initialOtherUnitQuantity,
            batchCode,
            batchId,
            initialAmount,
            billAmount,
            extendedAttributes,
            netAmount,
          } = item;
          const remarks = item?.remarks ?? ""
          if(remarks){
            if(!getRemarksStatus) setRemarksStatus(true)
          }
          const rejectedCaseQuantity = item?.rejectedCaseQuantity ?? 0
          const rejectedPieceQuantity = item?.rejectedPieceQuantity ?? 0
          const rejectedOtherUnitQuantity = item?.rejectedOtherUnitQuantity ?? 0
          footerCaseQuantity += rejectedCaseQuantity +initialCaseQuantity
          footerPieceQuantity += initialPieceQuantity+rejectedPieceQuantity
          footerOtherQuantity += initialOtherUnitQuantity+rejectedOtherUnitQuantity
          const piecePrice = item?.price ?? 0

        
          const taxInfo = extendedAttributes?.taxInfo ?? []
          const freeItem: boolean = type === "freeItem" 
            if(!freeItem) {
                taxInfo?.forEach((taxType: any) => (taxAmount += taxType?.taxAmount || 0));
            }
          totalInitialAmount += Number(initialAmount);
          totalAmount += Number(truncateToTwoDecimals(billAmount));
          totalFinalAmount += Number(truncateToTwoDecimals(netAmount));

          
          const id = `row-${index + 1}`;
          responseArray.push({
            id,
            type,
            skuCode,
            skuDescription,
            batchCode,
            batchId,
            category,
            pricePerCase: casePrice,
            actualAmount:initialAmount,
            initialCaseQuantity,
            initialPieceQuantity,
            initialOtherUnitQuantity,
            discount: Number(truncateToTwoDecimals(initialAmount - billAmount)),
            taxInfo,
            finalAmount: truncateToTwoDecimals(netAmount),
            accpeptedQtyObj: {
              acceptedQty: parseFloat(initialCaseQuantity),
              totalQty: parseFloat(initialCaseQuantity),
            },
            rejectedQtyObj: {
              rejectedQty: 0,
              totalQty: parseFloat(initialCaseQuantity),
            },

            accpeptedOtherQtyObj: {
              acceptedQty: parseFloat(initialOtherUnitQuantity),
              totalQty: parseFloat(initialOtherUnitQuantity),
            },
            rejectedOtherQtyObj: {
              rejectedQty: 0,
              totalQty: parseFloat(initialOtherUnitQuantity),
            },
            accpeptedPieceQtyObj: {
              acceptedQty: parseFloat(initialPieceQuantity),
              totalQty: parseFloat(initialPieceQuantity),
            },
            rejectedPieceQtyObj: {
              rejectedQty: 0,
              totalQty: parseFloat(initialPieceQuantity),
            },
            collapsed:  true,
            skuRejectionReason: remarks,
            rejectedCaseQuantity,
            rejectedPieceQuantity,
            rejectedOtherUnitQuantity,
            qtyCase:rejectedCaseQuantity +initialCaseQuantity,
          qtyPiece:initialPieceQuantity+rejectedPieceQuantity,
         qtyOtherUnit:initialOtherUnitQuantity+rejectedOtherUnitQuantity,
         piecePrice
          });
        });
        setTotalFooterValue([
          { headerName: "SKU Code", total: "Total" },
          { headerName: "Cases", total: footerCaseQuantity, textAlign: "center" },
          { headerName: "Pieces", total: footerPieceQuantity, textAlign: "center" },
          { headerName: "Others", total: footerOtherQuantity, textAlign: "center" },
          { headerName: "Amount", total: truncateToTwoDecimals(totalInitialAmount), textAlign: "left", currencySymbol: symbol },
          { headerName: "Final Amount", total: truncateToTwoDecimals(totalFinalAmount), textAlign: "left", currencySymbol: symbol },
        ])
        setRows(responseArray);
        setData(responseArray);
        setTotalTaxAmount(taxAmount);
      } else {
        throw new Error();
      }
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching GRN Details - ViewGrnDetails.tsx",
        `Failed to fetch GRN details for orderId ${orderId}. Error: ${(error as Error).message}`,
        safeStringify({ error, orderId })
      );
      setRows([]);
      openPopup("Something went wrong", "Error");
    }
  };

  const getOrderActionButtons = async () => {
    try {
      const stages = await getConfigData('order_configuration','grnStages');
      const primaryOrderStages = await getConfigData('order_configuration',"primaryOrderTrackingStages");
      setGrnStages(stages[0]?.configValue ?? [])
      setPrimaryOrderStages(primaryOrderStages[0]?.configValue ?? []);
      setActionButtons(stages);
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching GRN Action Buttons - ViewGrnDetails.tsx",
        `Failed to fetch GRN stages or primary order stages for orderId ${orderId}. Error: ${(error as Error).message}`,
        safeStringify({ error, orderId, configKeys: ["grnStages", "primaryOrderTrackingStages"] })
      );
      console.error(error);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const resetRejectOrderState = () => {
    setRejectCallBack(false);
    setRejectionReason("");
  };
  const handleReasonChange = (reason: string) => {
    setRejectionReason(reason);
  };

  const filteredData = useMemo(() => {
    return filterData(
      data,
      searchedValue.toLowerCase(),
      defaultSearchFunction
    );
  }, [searchedValue, data]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  const handleNavigateToViewAllGrn = () => {
    navigate('/dashboard/purchase/grn')
  }

  const init = async (orderId: string) => {
    // Start a custom trace for manage secondary order bulk invoice page load time
    const pageLoadTrace: PerformanceTrace = trace(performance, "view_grn_details_page_load_time");
    pageLoadTrace.start();

    setLoader(true);
    await Promise.allSettled([
      getAllOrderDetailsDataMethod(orderId),
      getOrderActionButtons(),
    ]).finally(() => {
      setLoader(false);
    });

    pageLoadTrace.stop();
  };

  const fetchRequiredConfigs = async () => {
    const res = await getConfigData("dms_configuration", "showPartiallyAcceptGrnButton");
    const showTaxPercentageConfig = await getConfigData("dms_configuration", "showTaxPercentage");
    const showPricePerPieceConfig = await getConfigData("dms_configuration", "showPricePerPieceViewEditGrnDetails");
    setShowPricePerPiece(showPricePerPieceConfig[0]?.configValue ?? false);
    showTaxPercentage.current = showTaxPercentageConfig[0]?.configValue ?? true;
    setPartialAcceptGrnButtonState(res[0]?.configValue ?? true);    
  };

   const init1 = () => {
    Promise.allSettled([fetchRequiredConfigs(), getRejectionReasonArray()])
  };

  useEffect(() => {
    init1();
  }, []);

  useEffect(() => {
    if (orderId) {
      init(orderId);
    } else {
      navigate("/dashboard/purchase/grn", { replace: true });
    }
  }, [orderId]);

useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (!orderStatusUpdateLoader && orderData?.grnStatus === 'OPEN' && !isEPOD.current) {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a' && !event.shiftKey) {
        event.preventDefault();
        if (isRejectCallBack) return;
        handleOrderStatusChange('ACCEPTED');
      } else if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'x') {
        event.preventDefault();
        if (isRejectCallBack) return;
        handleOrderStatusChange('REJECTED');
      } else if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a' && event.shiftKey && partialAcceptGrnButtonState) {
        event.preventDefault();
        if (isRejectCallBack) return;
        handleOrderStatusChange('PARTIALLY_ACCEPTED');
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [orderStatusUpdateLoader, orderData?.grnStatus, partialAcceptGrnButtonState, handleOrderStatusChange, isRejectCallBack]);

 const { positiveCta, negativeCta, ctrlKey } = useShortcutKeys();

  useEffect(() => {
      const el = scrollRef.current;
      if (!el) return;
  
      const handler = createScrollHandler(
        scrollRef,
        isScrolling,
        setAllowTableScroll,
        setDontContainerScroll
      );
  
      el.addEventListener("wheel", handler);
      el.addEventListener("scroll", handler);
  
      return () => {
        el.removeEventListener("wheel", handler);
        el.removeEventListener("scroll", handler);
      };
    }, [isScrolling, dontAllowContainerScroll]);

  if (loader) {
    return <Loader />;
  }

  return (
    <>
     <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          downloadGRNSheetLink={(orderData?.orderStatus === "DELIVERED" || orderData?.grnStatus?.toLowerCase() !== "open") ? "Download GRN for Signatures": ""}
          onClickDownloadGRNSheetLink={downloadGrnSheet}
          onClose={() => setGenericModalProps(initialGenericModalProps)}
        />
    <NewDiscountModalPrimary skuData={orderData} selectedSkuCode={selectedSkuCode} viewAllGrn={true}/>
      
      <div className="view_order_parent_vo" onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}>
        <div className="view_order_header_with_search">
          <div className="view_order_header">
            <FormHeader
              parentLabel={`View ${primaryOrderPath ? "Primary Order" : "All GRN"}`}
              label={"Invoice Details"}
              goBackToParent={handleNavigateToViewAllGrn}
            />
          </div>
          <div style={{width:"25%"}}>
            <Search searchFunction={handleSearchValueChange} />
          </div>
        </div>
        <div ref={scrollRef} style={{
          gap: "14px",
          overflow: (ConfigDictionary?.showTableScrollbar ? "auto" : (dontAllowContainerScroll ? "hidden" : "auto")), 
          height: "100%",
          scrollbarWidth: ConfigDictionary?.showTableScrollbar ? "thin" : "none",
        }}
          onScroll={(e) => {
            if (ConfigDictionary?.showTableScrollbar){
              const currentScrollTop = e.currentTarget.scrollTop;
              if (currentScrollTop > scrollTop) {
                setIsScrolling(true); // scrolling down
              } else if (currentScrollTop < scrollTop) {
                setIsScrolling(false); // scrolling up
              } 
            }
          }} 
        >
          <CustomAccordian
            expanded={!isScrolling}
            onCustomAccordionToggle={onCustomAccordionToggle}
            isSecondHalf={true}
            metaData1={getMetaData1(ConfigDictionary?.currency ? ConfigDictionary?.currency : "")}
            data1={{
              totalCasePieceOtherQuantity : getTotalQuantities(ConfigDictionary),
              totalQuantity : totalProducts,
              initialAmount : truncateToTwoDecimals(orderData?.totalAmount),
              discountValue: totalDiscount, 
              taxAmount : totalTaxAmount,
              netAmount : truncateToTwoDecimals(orderData?.netAmount)
            }}
            metaData2={metaData2()}
            data2={{
              supplierCode: orderData?.primarySupplier ?? orderData?.supplier,
              supplierName: orderData?.primarySupplierName ?? orderData?.supplierName,
              deliveryDate : deliveryDatePrimary,
              vechileNumber: orderData?.vechileNumber ?? "-",
              dispatchDate: orderData?.dispatchDate ? dayjs(orderData?.dispatchDate).format("YYYY-MM-DD") : "-",
              grnActionTime: orderData?.grnActionTime ?? "-",
            }}
            header={`GRN for Invoice No. ${orderData?.invoiceNumber}`}
            label1="Invoice Summary"
            label2="Supplier Summary"
            dateAndTimeLabel="Invoice Date & time"
            dateAndTimeValue={orderData?.creationTime}
            statusConfig={getGrnStages}
            status={orderData?.grnStatus}
          />
          <div style={{height: "100%", position: "sticky", top: "0"}}>
            {orderStatusUpdateLoader ? (
              <CircularProgress sx={{ margin: "0 auto", height: "50vh !important", display: "flex", alignItems: "center", justifyContent: "center" }} />
            ) : (
              <div className="view_order_details_vo">
                <div className="view_order_button_container">
                  <Header title={"Invoice Details"} />
                  { (orderData?.orderStatus === "DELIVERED" || orderData?.grnStatus?.toLowerCase() !== "open")  && (
                  <button
                    onClick={downloadGrnSheet}
                    className="ViewOrder_printInvoice"
                    disabled={grnSheetLoader}
                  >
                    <span>Download GRN for Signatures</span>&nbsp;
                    <span style={{ width: 20 }}>
                      {grnSheetLoader ? (
                        <CircularProgress
                          style={{
                            ...customStyle,
                            color: "#1D8DED",
                            height: 15,
                            width: 15,
                          }}
                        />
                      ) : (
                        <PdfIcon />
                      )}
                    </span>
                  </button>
                )}
                </div>
                {loader ? (
                  <Loader />
                ) : (
                    <CustomTablewithTotalInfo
                      data={rows}
                      columns={columns}
                      totals={totalFooterValue}
                      allowTableScroll={allowTableScroll}
                      setScrollTop={setScrollTop}
                      headerBackgroundColor="#F0FBFF"
                      children={(!isEPOD.current) ?
                          (<div className="view_order_update_wrapper">
                            <div className="view_order_action_buttons_wrapper">
                              <Button
                                hidden={orderData?.grnStatus !== "OPEN"}
                                startIcon={<RenderSvg name={"viewOrderREJECTED"} />}
                                className="view_order_action_button"
                                key={"REJECTED"}
                                sx={{
                                  color: `#ffffff !important`,
                                  fontWeight: 500,
                                  fontSize: `11px !important`,
                                  lineHeight: "2.25",
                                  backgroundColor: `#C64C00 !important`,
                                  textTransform: "none",
                                  border: `1px solid #C64C00 !important`,
                                  cursor: "pointer",
                                  padding: "6px 12px 6px 12px",
                                  height: "84%",
                                  "&:hover": {
                                    backgroundColor: `#C64C00 !important`,
                                  },
                                  "& .MuiButton-startIcon": {
                                    marginRight: "4px",
                                  },
                                }}
                                onClick={() => {
                                  handleOrderStatusChange("REJECTED");
                                }}
                              >
                                {"Reject GRN"}
                                &nbsp;<span style={{fontSize:"9.5px"}}>{negativeCta}</span>
                              </Button>
                              {partialAcceptGrnButtonState && (
                              <Button
                                hidden={orderData?.grnStatus !== "OPEN"}
                                startIcon={<RenderSvg name={"partiallyAcceptGrnIcon"} />}
                                className="view_order_action_button"
                                key={"PARTIALLYREJECTED"}
                                sx={{
                                  color: `#ffffff !important`,
                                  fontWeight: 500,
                                  fontSize: `11px !important`,
                                  lineHeight: "2.25",
                                  backgroundColor: `#BF7F17 !important`,
                                  border: `1px solid #BF7F17 !important`,
                                  cursor: "pointer",
                                  padding: "6px 12px 6px 12px",
                                  textTransform: "none",
                                  height: "84%",
                                  "&:hover": {
                                    backgroundColor: `#BF7F17 !important`,
                                  },
                                  "& .MuiButton-startIcon": {
                                    marginRight: "4px",
                                  },
                                }}
                                onClick={() => {
                                  handleOrderStatusChange("PARTIALLY_ACCEPTED");
                                }}
                              >
                                {"Partially Accept GRN"}
                                &nbsp;<span style={{fontSize:"9.5px"}}>{`(Shift + ${ctrlKey} + A)`}</span>
                              </Button>
                              )}
                              <Button
                                hidden={orderData?.grnStatus !== "OPEN"}
                                startIcon={<RenderSvg name={"viewOrderCONFIRMED"} />}
                                className="view_order_action_button"
                                key={"CONFIRMED"}
                                sx={{
                                  color: `#ffffff !important`,
                                  fontWeight: 500,
                                  fontSize: `11px !important`,
                                  lineHeight: "2.25",
                                  backgroundColor: `#00C6B1 !important`,
                                  border: `1px solid #00C6B1 !important`,
                                  cursor: "pointer",
                                  textTransform: "none",
                                  paddingLeft: "12px",
                                  height: "84%",
                                  "&:hover": {
                                    backgroundColor: `#00C6B1 !important`,
                                  },
                                  "& .MuiButton-startIcon": {
                                    marginRight: "4px",
                                  },
                                }}
                                onClick={() => {
                                  handleOrderStatusChange("ACCEPTED");
                                }}
                              >
                                {"Accept GRN"}
                                &nbsp;<span style={{fontSize:"9.5px"}}>{positiveCta}</span>
                              </Button>
                            </div>
                          </div>)
                          :
                          <></>
                        }
                    />
                )}
                
                <OrderCancelModal
                  headerText={`GRN is being rejected.`}
                  modalOpen={isRejectCallBack}
                  selectedRejectionReason={rejectionReason}
                  loading={false}
                  rejectionReasons={rejectionReasonsArray}
                  onClose={resetRejectOrderState}
                  handleReasonChange={handleReasonChange}
                  onButtonClick={() =>
                    closeCallbackForReject()
                  }
              />  
              </div>
            )}
          </div>
        </div>
      </div>
      <div></div>
    </>
  );
};

export default ViewGrnDetails;
